module.exports = __webpack_public_path__ + "static/media/main_large_1.152caf02.png";